import React, {PureComponent} from "react"
import gql from "graphql-tag"
import {ApolloQueryResult} from "apollo-client"
import {MutationProps} from "react-apollo"
import {DataProxy} from "apollo-cache"
import sentry from "@irati/utils/services/sentry"
import {Mutation} from "@irati/utils/services/apollo"
import {User, Poll, PollVote} from "@irati/types"
import partialUser from "@irati/identity/services/fragments/PartialUser"

import {openPollQuery} from "../../query/OpenPoll"
import {addVote} from "../../helpers/votes"

const graphQLMutation = gql`
  mutation createPollVote($vote: PollVoteInput!) {
    createPollVote(vote: $vote) {
      uuid
      message
      createdAt
      updatedAt
      createdBy {
        ...partialUser
      }
      user {
        ...partialUser
      }
      moderated
      archived
    }
  }
  ${partialUser}
`

interface Props extends Partial<MutationProps> {
  poll: Poll,
  user: User,
  message: string,
  children: any
}

interface Data {
  data: {
    createPollVote: PollVote
  }
}

interface CacheResult {
  poll: Poll | null
}

export default class CreatePollMutation extends PureComponent<Props> {
  static defaultProps = {
    message: ""
  }

  render() {
    const {poll, user, message, children, ...props} = this.props
    return (
      <Mutation mutation={graphQLMutation} {...props}>
        {(mutate: any, apolloState: ApolloQueryResult<Data>) =>
          children(
            () =>
              mutate({
                variables: {
                  vote: {
                    pollId: poll.uuid,
                    userId: user.uuid,
                    message
                  }
                },
                update: (cache: DataProxy, {data: {createPollVote: createdVote}}: Data) => {
                  try {
                    const query = {...openPollQuery, variables: {id: poll.uuid}}
                    const result: CacheResult | null = cache.readQuery(query)

                    if (result) {
                      const {poll: oldPoll} = result

                      if (oldPoll) {
                        const newPoll = addVote(oldPoll, createdVote)
                        cache.writeQuery({
                          ...query,
                          data: {
                            poll: newPoll
                          }
                        })
                      }
                    }
                  } catch (e) {
                    sentry.captureException(e)
                  }
                }
              }),
            apolloState
          )
        }
      </Mutation>
    )
  }
}
